import { Breadcrumb, BreadcrumbItem, Container } from "reactstrap";
import { BreadCrumbsTopNavStyle } from "./navbar.style";
import { useLocation, Link } from "react-router-dom";
import {memo} from "react";

export const NavbarSection = memo(() => {
    const location = useLocation();

    const breadcrumbs = [
        { label: "Shopping Cart", path: "/cart" },
        { label: "Review & Checkout", path: "/cart/checkout" },
        { label: "Order Complete", path: "/cart/order-complete" },
    ];

    return (
        <BreadCrumbsTopNavStyle>
            <Container>
                <Breadcrumb className="mb-0 flex-wrap">
                    {breadcrumbs.map((bc, idx) => {
                        const isActive = location.pathname === bc.path;
                        return (
                            <BreadcrumbItem
                                key={idx}
                                active={isActive}
                                className={`text-truncate ${
                                    !isActive ? "d-none d-sm-inline" : ""
                                }`}
                                style={{ maxWidth: "140px" }}
                            >
                                {isActive ? (
                                    bc.label
                                ) : (
                                    <Link to={bc.path} className="text-decoration-none">
                                        {bc.label}
                                    </Link>
                                )}
                            </BreadcrumbItem>
                        );
                    })}
                </Breadcrumb>
            </Container>
        </BreadCrumbsTopNavStyle>
    );
})